import { useContext } from "react";
import { MdContentCopy } from "react-icons/md";
import { AppContext } from "../App";
import { copyText } from "../Helpers";
import {
  MANUAL_IMPORTATION,
  MOBILE_GPS_MAPPING,
} from "../CoordinateSystems";
import {
  STR_COORDINATE_COPIED,
  STR_COPY,
  STR_COPY_FAILED,
  STR_MANUAL_IMPORTATION,
  STR_MAPPING_SOURCE,
  STR_MOBILE_GPS_MAPPING,
  STR_ORIGINAL_COORDINATES,
} from "../Strings";

export default function MappingSourceDetails({
  mappingMethod = MOBILE_GPS_MAPPING,
  metadata = {},
  originalPoints = [],
}) {
  const appContext = useContext(AppContext);
  const isManual = mappingMethod === MANUAL_IMPORTATION;
  const sourceDatum = metadata.sourceDatum || "WGS84";
  const sourceEpsg = metadata.sourceEpsg || "EPSG:4326";

  async function copyCoordinate(value) {
    const copied = await copyText(value);
    if (copied) {
      appContext.tellMessage(STR_COORDINATE_COPIED[appContext.language]);
    } else {
      appContext.tellError(STR_COPY_FAILED[appContext.language]);
    }
  }

  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="font-semi-bold mNoMargin">
            {STR_MAPPING_SOURCE[appContext.language]}
          </h6>
          <span className={`badge ${isManual ? "bg-primary" : "bg-dark"}`}>
            {
              isManual
                ? STR_MANUAL_IMPORTATION[appContext.language]
                : STR_MOBILE_GPS_MAPPING[appContext.language]
            }
          </span>
        </div>

        <div className="row">
          <div className="col-md-4 mb-2">
            <span className="text-muted">Datum</span><br />
            <span className="font-semi-bold">{sourceDatum}</span>
          </div>
          <div className="col-md-4 mb-2">
            <span className="text-muted">Source CRS</span><br />
            <span className="font-semi-bold">{sourceEpsg}</span>
          </div>
          <div className="col-md-4 mb-2">
            <span className="text-muted">Map CRS</span><br />
            <span className="font-semi-bold">{metadata.normalizedEpsg || "EPSG:4326"}</span>
          </div>
        </div>

        {metadata.transformationEpsg ? (
          <p className="text-muted mb-2" style={{ fontSize: "12px" }}>
            Transformation: {metadata.transformationEpsg}
          </p>
        ) : null}
        {metadata.originalUtmZone ? (
          <p className="mb-2">
            <span className="text-muted">Original UTM zone:</span>{" "}
            <span className="font-semi-bold">{metadata.originalUtmZone}</span>
          </p>
        ) : null}
        {metadata.sourceReference && metadata.sourceReference !== "mobile_gps" ? (
          <p className="mb-2">
            <span className="text-muted">Source reference:</span>{" "}
            <span className="font-semi-bold">{metadata.sourceReference}</span>
          </p>
        ) : null}

        {isManual && originalPoints.length > 0 ? (
          <div className="mt-3">
            <h6 className="text-muted">
              {STR_ORIGINAL_COORDINATES[appContext.language]} · {sourceDatum}
            </h6>
            {originalPoints.map((point, index) => {
              const value = `${point.lat}, ${point.lng}`;
              return (
                <div
                  className="d-flex justify-content-between align-items-center border-bottom py-2"
                  key={`${point.lat}-${point.lng}-${index}`}
                >
                  <span className="font-semi-bold me-2">#{index + 1}</span>
                  <span className="text-break mx-2">{value}</span>
                  <button
                    className="btn btn-sm btn-outline-dark"
                    onClick={() => copyCoordinate(value)}
                  >
                    <MdContentCopy className="me-1" />
                    {STR_COPY[appContext.language]}
                  </button>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
}
